import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { FiltersContext } from "components/Filters";
import { URL_FILTER_TAB_KEY } from "constants/urlQueryKeys";
import usePrevious from "hooks/usePrevious";
import useTypedContext from "hooks/useTypedContext";

import useStacksTableSelectionStore from "../Table/useStacksTableSelectionStore";

const StackFiltersLayoutSyncWithPredefinedTabs = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get(URL_FILTER_TAB_KEY);
  const prevTab = usePrevious(tab);

  const clearSelected = useStacksTableSelectionStore((state) => state.clearSelected);

  const { forceReMountSidebar, setActiveFiltersFromInitialParams } =
    useTypedContext(FiltersContext);

  useEffect(() => {
    if (prevTab !== tab) {
      forceReMountSidebar();
      setActiveFiltersFromInitialParams();
      clearSelected();
    }
  }, [prevTab, tab, forceReMountSidebar, setActiveFiltersFromInitialParams, clearSelected]);

  return null;
};

export default StackFiltersLayoutSyncWithPredefinedTabs;
